var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg400Ml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#47464A",
    fillRule: "evenodd",
    d: "M48.214 19.436h-5.786V10a2 2 0 0 0-2-2H12a2 2 0 0 0-2 2v40.681a5.793 5.793 0 0 0 5.786 5.787h20.855a5.793 5.793 0 0 0 5.787-5.787v-5.786h5.786A5.793 5.793 0 0 0 54 39.11V25.223a5.793 5.793 0 0 0-5.786-5.787zm-8.1-2.966h-5.787a1.158 1.158 0 0 0 0 2.315h5.787v31.896a3.477 3.477 0 0 1-3.473 3.473H15.786a3.477 3.477 0 0 1-3.472-3.473V18.785h15.07a1.158 1.158 0 1 0 0-2.315h-15.07v-6.003h27.8v6.003zM51.686 39.11a3.477 3.477 0 0 1-3.472 3.472h-5.786v-20.83h5.786a3.477 3.477 0 0 1 3.472 3.472v13.886z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg400Ml);
export default __webpack_public_path__ + "static/media/400_ml.8c1a7bd3805f394a9eb5006350aa8f2c.svg";
export { ForwardRef as ReactComponent };